import activitiesEvents from './events/activities';
import tasksEvents from './events/tasks';

function events(cell, e) {
  const { taskId, activityId } = cell.dataset;
  const clickedAddTaskButton = e.target.closest('[data-event-add-task]');
  const clickedAddSubTask = e.target.closest('[data-event-add-subtask]');
  const clickedDeleteButton = e.target.closest('[data-event-delete]');
  const clickedRoadblock = e.target.closest('[data-event-roadblock]');
  const clickedCreateTaskFromActivity = e.target.closest(
    '[data-event-create-task]'
  );
  const clickedDuplicateTaskFromActivity = e.target.closest(
    '[data-event-duplicate-task]'
  );

  if (clickedAddTaskButton) {
    tasksEvents.addTask(taskId);
    return;
  }

  if (clickedAddSubTask) {
    tasksEvents.addTaskToATask(taskId, activityId);
    return;
  }

  if (clickedDeleteButton) {
    tasksEvents.openDeleteTaskTooltip(taskId, clickedDeleteButton);
    e.stopPropagation();
    return;
  }

  if (clickedRoadblock) {
    tasksEvents.openRoadblockModal(taskId);
    return;
  }

  if (clickedCreateTaskFromActivity) {
    activitiesEvents.createTaskFromActivity(taskId);
    return;
  }

  if (clickedDuplicateTaskFromActivity) {
    activitiesEvents.duplicateActivity(taskId);
    return;
  }
}

export default events;
